(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('input', inputDirective);

    inputDirective.$inject = [];
    function inputDirective() {
        return {
            restrict: 'E',
            require: ['?ngModel'],
            link: link
        };

        function link(scope, element, attr, ctrl) {
            ctrl = ctrl[0];
            if (ctrl) 
                ctrl.$parsers.unshift(nullIfEmpty);

            function nullIfEmpty(value) {
                return ctrl.$isEmpty(value) ? null : value;
            }
        }
    }
})();
